import React from 'react';
import ListWrapper from './list-wrapper';

export default class EmptyList extends React.Component {

    render() {
        const { card, links } = this.props;

        if ( String(card.id).toLowerCase() === 'anexos' ) {
            return (
                <ListWrapper {...card} links={links}>
                    <section className='empty-attachment-wrapper'>
                        <i className='fa fa-paperclip' />
                        <h3>Você não possui anexos nesta turma</h3>
                    </section>
                </ListWrapper>
            );
        }

        return (
            <ListWrapper {...card} links={links} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/empty-list.js